export default function streamHasAuthType(stream = {}, authType) {
    if (stream.authTypes && authType) {
        return stream.authTypes.filter((auth) => auth === authType).length > 0
    }
    return false;
};



// WEBPACK FOOTER //
// ./app/lib/auth/streamHasAuthType.js